<div class="row">
	<div class="col-xs-12">
		<div class="list-items"></div>
	</div>
</div>
